import FieldPhoneNumber from 'shared/Forms/Fields/PhoneNumber/FieldPhoneNumber';
import InputPhoneNumber from 'shared/Forms/Inputs/PhoneNumber/InputPhoneNumber';
import React from 'react';
import InputHomePhone from 'shared/Forms/Inputs/PhoneNumber/InputHomePhone';

export default class FieldHomePhone extends React.Component {
	render() {
		return (
			<FieldPhoneNumber
				className={this.props.className}
				labelClass={this.props.labelClass}
				name={this.props.name}
				required={this.props.required}
				inputClass={this.props.inputClass}
				type="home"
			/>
		);
	}
}

FieldHomePhone.defaultProps = {
	autocomplete: InputPhoneNumber.defaultProps.autocomplete,
	className: InputPhoneNumber.defaultProps.className,
	inputClass: InputPhoneNumber.defaultProps.className,
	labelClass: FieldPhoneNumber.defaultProps.labelClass,
	name: InputHomePhone.defaultProps.name,
	required: InputPhoneNumber.defaultProps.required,
};
